export enum EInvitesStatus {
    INVITED = 'INVITED',
    REGISTERED = 'REGISTERED',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
  }
  